import React from "react";
import { Popover, Icon, Tooltip, Button } from "antd";
import isFunction from "lodash/isFunction";
import WeaLocaleProvider from "../../wea-locale-provider";
import WeaHelpfulTip from "../../wea-helpful-tip";
import WeaHrmlist from "../../wea-hrmlist";
import OGroup from "../components/OGroup";

const { getLabel } = WeaLocaleProvider;

export function getHrmPopover(props = {}) {
  return (
    <Popover
      placement="bottomLeft"
      title=""
      trigger="click"
      getTooltipContainer={() => this.searchWrapper}
      {...props}
    />
  );
}

export function addOnClick() {
  const { addOnClick } = this.props;
  isFunction(addOnClick) && addOnClick();
}

export function crmAddcb(data) {
  let datas = [];
  if (data.isAllUser) {
    datas.push({
      type: "all",
      count: data.count,
      ids: data.ids,
      lastname: getLabel(1340, "所有人")
    });
  } else {
    datas = data.datas;
  }
  this.props.appendSearchValues && this.props.appendSearchValues(datas, true);
}

export function getButtons() {
  const arr = [];
  const {
    data,
    isSingle,
    hasAddBtn,
    hasAddGroup,
    customIcon,
    customIconTip,
    helpfulTip,
    helpfulTipProps,
    viewAttr
  } = this.props;
  const { hrmlist, hrmlistStyle, hrmlistVisible, hrmVisible } = this.state;
  const disabled = this.hasAll();
  if (hasAddBtn) {
    arr.push(
      <div className="ant-input-group-wrap custom extbtn">
        <Icon className="add-icon" type="plus" onClick={this.addOnClick} />
      </div>
    );
  }
  if (customIcon) {
    let icon = (
      <i className={`${customIcon} add-icon`} onClick={this.addOnClick} />
    );
    if (customIconTip) {
      icon = (
        <Tooltip placement="bottom" title={customIconTip}>
          {icon}
        </Tooltip>
      );
    }
    arr.push(<div className="ant-input-group-wrap extbtn custom">{icon}</div>);
  }
  if (!isSingle && this.isCrm() && viewAttr != 1 && hasAddGroup) {
    const popupProps = {
      visible: hrmVisible,
      onVisibleChange: v => this.setState({ hrmVisible: v }),
      overlayClassName: "wea-hrm-group-popover",
      content: (
        <OGroup
          isshowoperategroup={hrmVisible}
          handleVisibleChange={v => this.setState({ hrmVisible: v })}
          setOperatorIds={this.crmAddcb}
        />
      ),
      children: (
        <Button
          type="primary"
          title={getLabel(84511, "快捷选择人员")}
          size="small"
          onClick={
            disabled ? undefined : () => this.setState({ hrmVisible: true })
          }
          disabled={disabled}
        >
          <i className="icon-coms-HumanResources" />
        </Button>
      )
    };
    arr.push(
      <div className="ant-input-group-wrap extbtn hasAddGroup">
        {this.getHrmPopover(popupProps)}
      </div>
    );
  }
  if (helpfulTip) {
    arr.push(
      <WeaHelpfulTip
        style={{ position: "absolute", right: -31, top: 4 }}
        title={helpfulTip}
        {...helpfulTipProps}
      />
    );
  }
  if (!isSingle) {
    const popupProps = {
      visible: hrmlistVisible,
      onVisibleChange: v => this.setState({ hrmlistVisible: v }),
      overlayClassName: "hrmlist-wrapper",
      content: (
        <WeaHrmlist
          list={hrmlist}
          onVisibleChange={v => this.setState({ hrmlistVisible: v })}
          style={hrmlistStyle}
          visible={hrmlistVisible}
        />
      ),
      children: <div className="hrmlistDom">&nbsp;</div>
    };
    arr.push(this.getHrmPopover(popupProps));
  }
  return arr;
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/associative/getButtons.js